import React from "react";

const AppBanner = ({ showMenuButton = false, onMenuClick }) => {
  return (
    <header className="bg-orange-400 text-white text-center py-2 sm:py-4 shadow-sm flex-shrink-0" style={{
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #1e40af 100%)'
    }}>
      <div className="relative flex items-center justify-center">
        {showMenuButton && (
          <button
            className="absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-md hover:bg-white hover:bg-opacity-20 text-white z-10"
            onClick={onMenuClick}
            style={{ left: 16 }}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        )}
        <div className={`flex-1 text-center ${showMenuButton ? 'pl-16 pr-16' : ''}`}>
          <h1 className="text-base sm:text-2xl font-bold leading-tight">
            Norma&apos;s Football League Pick&apos;Em
          </h1>
        </div>
      </div>
    </header>
  );
};

export default AppBanner;
